import editorReducer from './editorReducer'
export default editorReducer


// WEBPACK FOOTER //
// ./src/modules/BranchEditor/ProductEditor/editorReducer/index.js